import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { name: "form" }
const _hoisted_4 = { class: "contain row" }
const _hoisted_5 = {
  key: 1,
  class: "page-container card col-md-8"
}
const _hoisted_6 = {
  key: 0,
  class: "row"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-fw pi-file" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "Info", -1)
const _hoisted_9 = {
  key: 1,
  class: "row"
}
const _hoisted_10 = { class: "col-md-12 p-4" }
const _hoisted_11 = { class: "row mb-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3 required" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Code:")
], -1)
const _hoisted_13 = { class: "col-md-6" }
const _hoisted_14 = { class: "row mb-3" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3 required" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Title:")
], -1)
const _hoisted_16 = { class: "col-md-6" }
const _hoisted_17 = { class: "row mb-3" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3 required" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Sequence:")
], -1)
const _hoisted_19 = { class: "col-md-6" }
const _hoisted_20 = { class: "col-md-3" }
const _hoisted_21 = {
  key: 0,
  class: "row mb-3"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3 required" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Status:")
], -1)
const _hoisted_23 = { class: "col-md-6" }
const _hoisted_24 = { class: "row mb-3" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3" }, null, -1)
const _hoisted_26 = { class: "d-flex col-md-6" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "p-1" }, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-fw pi-book" }, null, -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", null, "Template", -1)
const _hoisted_30 = {
  key: 1,
  class: "row"
}
const _hoisted_31 = { class: "row p-3" }
const _hoisted_32 = { class: "col-md-5 d-flex align-items-center" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", { class: "p-1" }, null, -1)
const _hoisted_34 = { class: "col-md-7" }
const _hoisted_35 = { class: "row" }
const _hoisted_36 = { class: "col-md-12 p-4" }
const _hoisted_37 = { class: "p-datatable p-component p-datatable-hoverable-rows align-middle mb-0 w-12" }
const _hoisted_38 = { class: "p-datatable-thead" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("th", { style: {"width":"6%"} }, "#", -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("th", {
  style: {"width":"10%"},
  class: "text-center"
}, "Status", -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("th", {
  style: {"width":"10%"},
  class: "text-center"
}, "Action", -1)
const _hoisted_42 = {
  key: 0,
  class: "p-datatable-tbody"
}
const _hoisted_43 = ["onClick"]
const _hoisted_44 = ["onClick"]
const _hoisted_45 = ["onClick"]
const _hoisted_46 = ["onClick"]
const _hoisted_47 = ["onClick"]
const _hoisted_48 = ["onClick"]
const _hoisted_49 = { class: "text-center" }
const _hoisted_50 = { class: "d-flex justify-content-center" }
const _hoisted_51 = {
  key: 0,
  class: "error-no-record"
}
const _hoisted_52 = /*#__PURE__*/_createElementVNode("h6", null, [
  /*#__PURE__*/_createElementVNode("span", null, "No Record Found")
], -1)
const _hoisted_53 = { class: "row" }
const _hoisted_54 = { class: "col-md-12 d-flex align-items-center mb-3 mb-md-0 me-md-auto text-decoration-none" }
const _hoisted_55 = { class: "fs-5" }
const _hoisted_56 = { class: "p-3" }
const _hoisted_57 = { class: "col-form-label-title" }
const _hoisted_58 = { class: "d-flex justify-content-end p-2" }
const _hoisted_59 = { class: "row p-3" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-5 d-flex align-items-center" }, null, -1)
const _hoisted_61 = { class: "col-md-7" }
const _hoisted_62 = { class: "row" }
const _hoisted_63 = { class: "col-md-12 p-4" }
const _hoisted_64 = { class: "p-datatable p-component p-datatable-hoverable-rows align-middle mb-0 w-12" }
const _hoisted_65 = { class: "p-datatable-thead" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("th", {
  style: {"width":"5%"},
  class: "text-center"
}, null, -1)
const _hoisted_67 = /*#__PURE__*/_createElementVNode("th", { style: {"width":"7%"} }, "#", -1)
const _hoisted_68 = /*#__PURE__*/_createElementVNode("th", {
  style: {"width":"14%"},
  class: "text-center"
}, "Status", -1)
const _hoisted_69 = {
  key: 0,
  class: "p-datatable-tbody"
}
const _hoisted_70 = { class: "text-center" }
const _hoisted_71 = {
  key: 0,
  class: "error-no-record"
}
const _hoisted_72 = /*#__PURE__*/_createElementVNode("h6", null, [
  /*#__PURE__*/_createElementVNode("span", null, "No Record Found")
], -1)
const _hoisted_73 = { class: "d-flex justify-content-end p-2" }
const _hoisted_74 = { class: "row" }
const _hoisted_75 = { class: "col-md-12 p-4" }
const _hoisted_76 = { class: "p-datatable p-component p-datatable-hoverable-rows align-middle mb-0 w-12" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("thead", { class: "p-datatable-thead" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"7%"} }, "#"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"22%"} }, "Created Date"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"22%"} }, "Last Modified Date"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"13%"} }, "Version"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"12%"} }, "Sheets"),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"width":"24%"},
      class: "text-center"
    }, "This Sheet")
  ])
], -1)
const _hoisted_78 = {
  key: 0,
  class: "p-datatable-tbody"
}
const _hoisted_79 = ["title", "onClick"]
const _hoisted_80 = { class: "text-center" }
const _hoisted_81 = {
  key: 0,
  class: "error-no-record"
}
const _hoisted_82 = /*#__PURE__*/_createElementVNode("h6", null, [
  /*#__PURE__*/_createElementVNode("span", null, "No Draft Version Found")
], -1)
const _hoisted_83 = { class: "d-flex justify-content-end p-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheHeader = _resolveComponent("TheHeader")!
  const _component_TheSidebar = _resolveComponent("TheSidebar")!
  const _component_ThePageLoading = _resolveComponent("ThePageLoading")!
  const _component_ThePageHeader = _resolveComponent("ThePageHeader")!
  const _component_TheTabViewLoading = _resolveComponent("TheTabViewLoading")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_TheLoading = _resolveComponent("TheLoading")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_Paginator = _resolveComponent("Paginator")!
  const _component_Badge = _resolveComponent("Badge")!
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_TheTableLoading = _resolveComponent("TheTableLoading")!
  const _component_TabView = _resolveComponent("TabView")!
  const _component_TheTemplateDialog = _resolveComponent("TheTemplateDialog")!
  const _component_ThePageError = _resolveComponent("ThePageError")!
  const _component_TheFooter = _resolveComponent("TheFooter")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_Checkbox = _resolveComponent("Checkbox")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_TheHeader),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("form", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_TheSidebar),
            (_ctx.isPageLoading)
              ? (_openBlock(), _createBlock(_component_ThePageLoading, { key: 0 }))
              : _createCommentVNode("", true),
            (!_ctx.isPageLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  (_openBlock(), _createBlock(_component_ThePageHeader, {
                    onImportTxtEvent: _cache[0] || (_cache[0] = (files) => _ctx.importTemplate(files, 'txt')),
                    onImportExcelEvent: _cache[1] || (_cache[1] = (files) => _ctx.importTemplate(files, 'excel')),
                    onExportZipEvent: _cache[2] || (_cache[2] = () => _ctx.showExportTemplateDialog('zip')),
                    onExportExcelEvent: _cache[3] || (_cache[3] = () => _ctx.showExportTemplateDialog('excel')),
                    onDeleteEvent: _ctx.deleteSheet,
                    key: _ctx.isImporting && _ctx.isExporting && _ctx.isDeleting,
                    renderImportTemplate: _ctx.activeIndex == 1,
                    isImporting: _ctx.isImporting,
                    renderExportTemplate: _ctx.activeIndex == 1,
                    isExporting: _ctx.isExporting,
                    renderDelete: _ctx.identifier != null && _ctx.activeIndex == 0,
                    isDeleting: _ctx.isDeleting
                  }, null, 8, ["onDeleteEvent", "renderImportTemplate", "isImporting", "renderExportTemplate", "isExporting", "renderDelete", "isDeleting"])),
                  (_ctx.pageError == '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createVNode(_component_TabView, {
                          class: "p-1",
                          activeIndex: _ctx.activeIndex,
                          "onUpdate:activeIndex": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.activeIndex) = $event)),
                          onTabChange: _ctx.onTabChange
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_TabPanel, null, {
                              header: _withCtx(() => [
                                _hoisted_7,
                                _hoisted_8
                              ]),
                              default: _withCtx(() => [
                                (_ctx.isPageLoading)
                                  ? (_openBlock(), _createBlock(_component_TheTabViewLoading, { key: 0 }))
                                  : _createCommentVNode("", true),
                                (!_ctx.isPageLoading)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                      _createElementVNode("div", _hoisted_10, [
                                        _createElementVNode("div", _hoisted_11, [
                                          _hoisted_12,
                                          _createElementVNode("div", _hoisted_13, [
                                            _createVNode(_component_InputText, {
                                              class: "p-inputtext",
                                              type: "text",
                                              maxlength: "10",
                                              placeholder: "Code",
                                              modelValue: _ctx.sheet.code,
                                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.sheet.code) = $event))
                                            }, null, 8, ["modelValue"])
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_14, [
                                          _hoisted_15,
                                          _createElementVNode("div", _hoisted_16, [
                                            _createVNode(_component_InputText, {
                                              class: "p-inputtext",
                                              type: "text",
                                              maxlength: "50",
                                              placeholder: "Title",
                                              modelValue: _ctx.sheet.name,
                                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.sheet.name) = $event))
                                            }, null, 8, ["modelValue"])
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_17, [
                                          _hoisted_18,
                                          _createElementVNode("div", _hoisted_19, [
                                            _createVNode(_component_InputNumber, {
                                              min: 1,
                                              max: 200,
                                              modelValue: _ctx.sheet.sequence,
                                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.sheet.sequence) = $event)),
                                              disabled: _ctx.sheet.type == null || _ctx.sheet.type == ''
                                            }, null, 8, ["modelValue", "disabled"])
                                          ]),
                                          _createElementVNode("div", _hoisted_20, [
                                            _createVNode(_component_Button, {
                                              class: "p-button-sm",
                                              label: "Next Sequence",
                                              onClick: _ctx.getNextSequence,
                                              disabled: _ctx.sheet.type == null || _ctx.sheet.type == ''
                                            }, null, 8, ["onClick", "disabled"])
                                          ])
                                        ]),
                                        (_ctx.identifier != null)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                              _hoisted_22,
                                              _createElementVNode("div", _hoisted_23, [
                                                _createVNode(_component_Dropdown, {
                                                  options: _ctx.getActiveStatuses(_ctx.statuses),
                                                  optionLabel: "name",
                                                  optionValue: "value",
                                                  placeholder: "-- Please Select --",
                                                  modelValue: _ctx.sheet.isClosed,
                                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.sheet.isClosed) = $event))
                                                }, null, 8, ["options", "modelValue"])
                                              ])
                                            ]))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("div", _hoisted_24, [
                                          _hoisted_25,
                                          _createElementVNode("div", _hoisted_26, [
                                            _createVNode(_component_Button, {
                                              class: "p-button-sm",
                                              disabled: _ctx.v$.sheet.$invalid || _ctx.isLoading,
                                              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.identifier == null ? _ctx.save() : _ctx.update())),
                                              label: "Save"
                                            }, null, 8, ["disabled"]),
                                            _hoisted_27,
                                            _createVNode(_component_Button, {
                                              class: "p-button-sm p-button-secondary",
                                              onClick: _ctx.cancel,
                                              label: "Cancel"
                                            }, null, 8, ["onClick"]),
                                            (_ctx.isLoading)
                                              ? (_openBlock(), _createBlock(_component_TheLoading, { key: 0 }))
                                              : _createCommentVNode("", true)
                                          ])
                                        ])
                                      ])
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }),
                            (_ctx.identifier != null)
                              ? (_openBlock(), _createBlock(_component_TabPanel, { key: 0 }, {
                                  header: _withCtx(() => [
                                    _hoisted_28,
                                    _hoisted_29
                                  ]),
                                  default: _withCtx(() => [
                                    (_ctx.isPageLoading)
                                      ? (_openBlock(), _createBlock(_component_TheTabViewLoading, { key: 0 }))
                                      : _createCommentVNode("", true),
                                    (!_ctx.isPageLoading)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                          _createElementVNode("div", _hoisted_31, [
                                            _createElementVNode("div", _hoisted_32, [
                                              _createVNode(_component_Button, {
                                                class: "p-button-sm",
                                                onClick: _ctx.addTemplate,
                                                label: "Add",
                                                disabled: _ctx.pagination.totalItems > 0
                                              }, null, 8, ["onClick", "disabled"]),
                                              _hoisted_33
                                            ]),
                                            _createElementVNode("div", _hoisted_34, [
                                              (_ctx.pagination.currentPage != 0)
                                                ? (_openBlock(), _createBlock(_component_Paginator, {
                                                    key: 0,
                                                    first: _ctx.paginator,
                                                    pageLinkSize: 3,
                                                    rows: _ctx.pagination.itemsPerPage,
                                                    totalRecords: _ctx.pagination.totalItems,
                                                    onPage: _cache[9] || (_cache[9] = ($event: any) => (_ctx.find($event.page + 1)))
                                                  }, null, 8, ["first", "rows", "totalRecords"]))
                                                : _createCommentVNode("", true)
                                            ])
                                          ]),
                                          _createElementVNode("div", _hoisted_35, [
                                            _createElementVNode("div", _hoisted_36, [
                                              _createElementVNode("table", _hoisted_37, [
                                                _createElementVNode("thead", _hoisted_38, [
                                                  _createElementVNode("tr", null, [
                                                    _hoisted_39,
                                                    _createElementVNode("th", {
                                                      style: {"width":"20%","cursor":"pointer"},
                                                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.sort('x.createdDate')))
                                                    }, [
                                                      _createTextVNode("Created Date "),
                                                      _createElementVNode("span", {
                                                        class: _normalizeClass(["pi", [_ctx.sortingModel.columnName == 'x.createdDate' ? (_ctx.sortingModel.isAscending ? 'pi-sort-amount-up-alt' : 'pi-sort-amount-down') : 'pi-fw pi-sort-alt']])
                                                      }, null, 2)
                                                    ]),
                                                    _createElementVNode("th", {
                                                      style: {"width":"22%","cursor":"pointer"},
                                                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.sort('x.lastModifiedDate')))
                                                    }, [
                                                      _createTextVNode("Last Modified Date "),
                                                      _createElementVNode("span", {
                                                        class: _normalizeClass(["pi", [_ctx.sortingModel.columnName == 'x.lastModifiedDate' ? (_ctx.sortingModel.isAscending ? 'pi-sort-amount-up-alt' : 'pi-sort-amount-down') : 'pi-fw pi-sort-alt']])
                                                      }, null, 2)
                                                    ]),
                                                    _createElementVNode("th", {
                                                      style: {"width":"20%","cursor":"pointer"},
                                                      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.sort('x.publishedDate')))
                                                    }, [
                                                      _createTextVNode("Published Date "),
                                                      _createElementVNode("span", {
                                                        class: _normalizeClass(["pi", [_ctx.sortingModel.columnName == 'x.publishedDate' ? (_ctx.sortingModel.isAscending ? 'pi-sort-amount-up-alt' : 'pi-sort-amount-down') : 'pi-fw pi-sort-alt']])
                                                      }, null, 2)
                                                    ]),
                                                    _createElementVNode("th", {
                                                      style: {"width":"12%","cursor":"pointer"},
                                                      onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.sort('x.version')))
                                                    }, [
                                                      _createTextVNode("Version "),
                                                      _createElementVNode("span", {
                                                        class: _normalizeClass(["pi", [_ctx.sortingModel.columnName == 'x.version' ? (_ctx.sortingModel.isAscending ? 'pi-sort-amount-up-alt' : 'pi-sort-amount-down') : 'pi-fw pi-sort-alt']])
                                                      }, null, 2)
                                                    ]),
                                                    _hoisted_40,
                                                    _hoisted_41
                                                  ])
                                                ]),
                                                (!_ctx.isLoading)
                                                  ? (_openBlock(), _createElementBlock("tbody", _hoisted_42, [
                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pagination.templates, (template, index) => {
                                                        return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                                          _createElementVNode("td", {
                                                            onClick: ($event: any) => (_ctx.viewTemplate(template))
                                                          }, _toDisplayString(((_ctx.pagination.currentPage - 1) * _ctx.pagination.itemsPerPage) + index + 1), 9, _hoisted_43),
                                                          _createElementVNode("td", {
                                                            onClick: ($event: any) => (_ctx.viewTemplate(template))
                                                          }, _toDisplayString(template.createdDate), 9, _hoisted_44),
                                                          _createElementVNode("td", {
                                                            onClick: ($event: any) => (_ctx.viewTemplate(template))
                                                          }, _toDisplayString(template.lastModifiedDate), 9, _hoisted_45),
                                                          _createElementVNode("td", {
                                                            onClick: ($event: any) => (_ctx.viewTemplate(template))
                                                          }, _toDisplayString(template.publishedDate), 9, _hoisted_46),
                                                          _createElementVNode("td", {
                                                            onClick: ($event: any) => (_ctx.viewTemplate(template)),
                                                            class: "text-center"
                                                          }, _toDisplayString(_ctx.displayTemplateVersion(template)), 9, _hoisted_47),
                                                          _createElementVNode("td", {
                                                            onClick: ($event: any) => (_ctx.viewTemplate(template)),
                                                            class: "text-center"
                                                          }, [
                                                            (template.status != null)
                                                              ? (_openBlock(), _createBlock(_component_Badge, {
                                                                  key: 0,
                                                                  class: _normalizeClass(["mr-2", template.publishedDate == null ? 'p-badge-danger' : template.status == 'Active' ? 'p-badge-success' : 'p-badge-secondary']),
                                                                  value: template.publishedDate == null ? 'Draft' : 'Published'
                                                                }, null, 8, ["class", "value"]))
                                                              : _createCommentVNode("", true)
                                                          ], 8, _hoisted_48),
                                                          _createElementVNode("td", _hoisted_49, [
                                                            _createElementVNode("div", _hoisted_50, [
                                                              (template.status != 'Active')
                                                                ? (_openBlock(), _createBlock(_component_Button, {
                                                                    key: 0,
                                                                    icon: "pi pi-upload",
                                                                    title: template.publishedDate == null ? 'Publish' : 'Republish',
                                                                    severity: "warning",
                                                                    text: "",
                                                                    rounded: "",
                                                                    onClick: ($event: any) => (_ctx.publishTemplate(template))
                                                                  }, null, 8, ["title", "onClick"]))
                                                                : _createCommentVNode("", true),
                                                              (template.publishedDate != null)
                                                                ? (_openBlock(), _createBlock(_component_Button, {
                                                                    key: 1,
                                                                    icon: "pi pi-clone",
                                                                    title: "Clone (new draft version for all active sheets)",
                                                                    severity: "primary",
                                                                    text: "",
                                                                    rounded: "",
                                                                    onClick: ($event: any) => (_ctx.cloneTemplate(template))
                                                                  }, null, 8, ["onClick"]))
                                                                : _createCommentVNode("", true),
                                                              (template.publishedDate != null)
                                                                ? (_openBlock(), _createBlock(_component_Button, {
                                                                    key: 2,
                                                                    icon: "pi pi-copy",
                                                                    title: "Clone this sheet only into an existing draft version",
                                                                    severity: "info",
                                                                    text: "",
                                                                    rounded: "",
                                                                    onClick: ($event: any) => (_ctx.showCloneSingleDialog(template))
                                                                  }, null, 8, ["onClick"]))
                                                                : _createCommentVNode("", true),
                                                              (template.publishedDate == null)
                                                                ? (_openBlock(), _createBlock(_component_Button, {
                                                                    key: 3,
                                                                    icon: "pi pi-minus-circle",
                                                                    title: "Delete this draft only (other sheets in the version are kept)",
                                                                    severity: "danger",
                                                                    text: "",
                                                                    rounded: "",
                                                                    onClick: ($event: any) => (_ctx.deleteTemplateSingle(template))
                                                                  }, null, 8, ["onClick"]))
                                                                : _createCommentVNode("", true),
                                                              (template.publishedDate == null)
                                                                ? (_openBlock(), _createBlock(_component_Button, {
                                                                    key: 4,
                                                                    icon: "pi pi-trash",
                                                                    title: "Delete all drafts of this version",
                                                                    severity: "danger",
                                                                    text: "",
                                                                    rounded: "",
                                                                    onClick: ($event: any) => (_ctx.deleteTemplate(template))
                                                                  }, null, 8, ["onClick"]))
                                                                : _createCommentVNode("", true)
                                                            ])
                                                          ])
                                                        ]))
                                                      }), 128))
                                                    ]))
                                                  : _createCommentVNode("", true)
                                              ])
                                            ]),
                                            (!_ctx.isLoading && _ctx.pagination.templates.length == 0)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                                                  _createVNode(_component_FontAwesomeIcon, {
                                                    icon: ['fas', 'image'],
                                                    size: "2x"
                                                  }),
                                                  _hoisted_52
                                                ]))
                                              : _createCommentVNode("", true),
                                            (_ctx.isLoading)
                                              ? (_openBlock(), _createBlock(_component_TheTableLoading, { key: 1 }))
                                              : _createCommentVNode("", true)
                                          ])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 8, ["activeIndex", "onTabChange"])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_TheTemplateDialog, {
                    sheetType: _ctx.sheet.type,
                    identifier: _ctx.dialog.identifier,
                    version: _ctx.dialog.version,
                    publishedDate: _ctx.dialog.publishedDate,
                    status: _ctx.dialog.status,
                    header: _ctx.dialog.header,
                    headerCode: _ctx.dialog.headerCode,
                    visible: _ctx.dialog.visible,
                    loading: _ctx.dialog.loading,
                    onSave: _ctx.saveTemplate,
                    onUpdate: _ctx.updateTemplate,
                    onCancel: _ctx.closeDialog
                  }, null, 8, ["sheetType", "identifier", "version", "publishedDate", "status", "header", "headerCode", "visible", "loading", "onSave", "onUpdate", "onCancel"]),
                  (_ctx.pageError != '')
                    ? (_openBlock(), _createBlock(_component_ThePageError, {
                        key: 1,
                        onBackEvent: _ctx.cancel,
                        pageError: _ctx.pageError
                      }, null, 8, ["onBackEvent", "pageError"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_TheFooter)
          ])
        ])
      ])
    ]),
    _createVNode(_component_Dialog, {
      header: "Import Preview",
      visible: _ctx.displayModal,
      "onUpdate:visible": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.displayModal) = $event)),
      draggable: false,
      style: {width: '60vw'},
      onHide: _ctx.closeModal
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_58, [
          (_ctx.isDialogLoading)
            ? (_openBlock(), _createBlock(_component_TheLoading, { key: 0 }))
            : _createCommentVNode("", true),
          _createVNode(_component_Button, {
            class: "p-button-text p-button-sm",
            label: "Cancel",
            icon: "pi pi-times",
            onClick: _ctx.closeModal
          }, null, 8, ["onClick"]),
          _createVNode(_component_Button, {
            class: "p-button-sm",
            label: "Proceed",
            icon: "pi pi-check",
            onClick: _ctx.proceedImport,
            autofocus: ""
          }, null, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_53, [
          _createElementVNode("div", _hoisted_54, [
            _createElementVNode("span", _hoisted_55, [
              _createElementVNode("div", _hoisted_56, [
                _createElementVNode("pre", null, [
                  _createElementVNode("label", _hoisted_57, _toDisplayString(_ctx.templateContent), 1)
                ])
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible", "onHide"]),
    _createVNode(_component_Dialog, {
      header: "Template",
      visible: _ctx.exportTemplateDialog.visible,
      "onUpdate:visible": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.exportTemplateDialog.visible) = $event)),
      draggable: false,
      style: {width: '60vw'},
      onHide: _ctx.hideExportTemplateDialog
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_73, [
          _createVNode(_component_Button, {
            class: "p-button-text p-button-sm",
            label: "Cancel",
            icon: "pi pi-times",
            onClick: _ctx.hideExportTemplateDialog
          }, null, 8, ["onClick"]),
          _createVNode(_component_Button, {
            class: "p-button-sm",
            label: "Export",
            icon: "pi pi-check",
            onClick: _ctx.exportTemplate,
            disabled: _ctx.exportTemplateDialog.selectedTemplates.length == 0
          }, null, 8, ["onClick", "disabled"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_59, [
          _hoisted_60,
          _createElementVNode("div", _hoisted_61, [
            (_ctx.exportTemplateDialog.pagination.currentPage != 0)
              ? (_openBlock(), _createBlock(_component_Paginator, {
                  key: 0,
                  first: _ctx.paginator,
                  pageLinkSize: 3,
                  rows: _ctx.exportTemplateDialog.pagination.itemsPerPage,
                  totalRecords: _ctx.exportTemplateDialog.pagination.totalItems,
                  onPage: _cache[16] || (_cache[16] = ($event: any) => (_ctx.findExportTemplates($event.page + 1)))
                }, null, 8, ["first", "rows", "totalRecords"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_62, [
          _createElementVNode("div", _hoisted_63, [
            _createElementVNode("table", _hoisted_64, [
              _createElementVNode("thead", _hoisted_65, [
                _createElementVNode("tr", null, [
                  _hoisted_66,
                  _hoisted_67,
                  _createElementVNode("th", {
                    style: {"width":"20%","cursor":"pointer"},
                    onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.sort('x.createdDate')))
                  }, [
                    _createTextVNode("Created Date "),
                    _createElementVNode("span", {
                      class: _normalizeClass(["pi", [_ctx.sortingModel.columnName == 'x.createdDate' ? (_ctx.sortingModel.isAscending ? 'pi-sort-amount-up-alt' : 'pi-sort-amount-down') : 'pi-fw pi-sort-alt']])
                    }, null, 2)
                  ]),
                  _createElementVNode("th", {
                    style: {"width":"20%","cursor":"pointer"},
                    onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.sort('x.lastModifiedDate')))
                  }, [
                    _createTextVNode("Last Modified Date "),
                    _createElementVNode("span", {
                      class: _normalizeClass(["pi", [_ctx.sortingModel.columnName == 'x.lastModifiedDate' ? (_ctx.sortingModel.isAscending ? 'pi-sort-amount-up-alt' : 'pi-sort-amount-down') : 'pi-fw pi-sort-alt']])
                    }, null, 2)
                  ]),
                  _createElementVNode("th", {
                    style: {"width":"20%","cursor":"pointer"},
                    onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.sort('x.publishedDate')))
                  }, [
                    _createTextVNode("Published Date "),
                    _createElementVNode("span", {
                      class: _normalizeClass(["pi", [_ctx.sortingModel.columnName == 'x.publishedDate' ? (_ctx.sortingModel.isAscending ? 'pi-sort-amount-up-alt' : 'pi-sort-amount-down') : 'pi-fw pi-sort-alt']])
                    }, null, 2)
                  ]),
                  _createElementVNode("th", {
                    style: {"width":"14%","cursor":"pointer"},
                    onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.sort('x.version')))
                  }, [
                    _createTextVNode("Version "),
                    _createElementVNode("span", {
                      class: _normalizeClass(["pi", [_ctx.sortingModel.columnName == 'x.version' ? (_ctx.sortingModel.isAscending ? 'pi-sort-amount-up-alt' : 'pi-sort-amount-down') : 'pi-fw pi-sort-alt']])
                    }, null, 2)
                  ]),
                  _hoisted_68
                ])
              ]),
              (!_ctx.exportTemplateDialog.isLoading)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_69, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.exportTemplateDialog.pagination.templates, (template, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("td", null, [
                          _createVNode(_component_Checkbox, {
                            modelValue: _ctx.exportTemplateDialog.selectedTemplates,
                            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.exportTemplateDialog.selectedTemplates) = $event)),
                            value: template.identifier
                          }, null, 8, ["modelValue", "value"])
                        ]),
                        _createElementVNode("td", null, _toDisplayString(((_ctx.exportTemplateDialog.pagination.currentPage - 1) * _ctx.exportTemplateDialog.pagination.itemsPerPage) + index + 1), 1),
                        _createElementVNode("td", null, _toDisplayString(template.createdDate), 1),
                        _createElementVNode("td", null, _toDisplayString(template.lastModifiedDate), 1),
                        _createElementVNode("td", null, _toDisplayString(template.publishedDate), 1),
                        _createElementVNode("td", null, _toDisplayString(template.version), 1),
                        _createElementVNode("td", _hoisted_70, [
                          (template.status != null)
                            ? (_openBlock(), _createBlock(_component_Badge, {
                                key: 0,
                                class: _normalizeClass(["mr-2", template.publishedDate == null ? 'p-badge-danger' : template.status == 'Active' ? 'p-badge-success' : 'p-badge-secondary']),
                                value: template.publishedDate == null ? 'Draft' : 'Published'
                              }, null, 8, ["class", "value"]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        (!_ctx.exportTemplateDialog.isLoading && _ctx.exportTemplateDialog.pagination.templates.length == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
              _createVNode(_component_FontAwesomeIcon, {
                icon: ['fas', 'image'],
                size: "2x"
              }),
              _hoisted_72
            ]))
          : _createCommentVNode("", true),
        (_ctx.exportTemplateDialog.isLoading)
          ? (_openBlock(), _createBlock(_component_TheTableLoading, { key: 1 }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible", "onHide"]),
    _createVNode(_component_Dialog, {
      header: 'Clone Version ' + (_ctx.cloneSingleDialog.template ? _ctx.cloneSingleDialog.template.version : '') + ' Into Draft Version',
      visible: _ctx.cloneSingleDialog.visible,
      "onUpdate:visible": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.cloneSingleDialog.visible) = $event)),
      draggable: false,
      style: {width: '60vw'},
      onHide: _ctx.hideCloneSingleDialog
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_83, [
          _createVNode(_component_Button, {
            class: "p-button-text p-button-sm",
            label: "Cancel",
            icon: "pi pi-times",
            onClick: _ctx.hideCloneSingleDialog
          }, null, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_74, [
          _createElementVNode("div", _hoisted_75, [
            _createElementVNode("table", _hoisted_76, [
              _hoisted_77,
              (!_ctx.cloneSingleDialog.isLoading)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_78, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cloneSingleDialog.versions, (row, index) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: row.version,
                        style: _normalizeStyle({cursor: row.hasSheetDraft ? 'not-allowed' : 'pointer', opacity: row.hasSheetDraft ? 0.5 : 1}),
                        title: row.hasSheetDraft ? 'This sheet already has a draft in this version - delete that draft first' : 'Clone into this draft version',
                        onClick: ($event: any) => (_ctx.cloneTemplateSingle(row))
                      }, [
                        _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                        _createElementVNode("td", null, _toDisplayString(row.createdDate), 1),
                        _createElementVNode("td", null, _toDisplayString(row.lastModifiedDate), 1),
                        _createElementVNode("td", null, _toDisplayString(_ctx.displaySetVersion(row)), 1),
                        _createElementVNode("td", null, _toDisplayString(row.sheetCount), 1),
                        _createElementVNode("td", _hoisted_80, [
                          _createVNode(_component_Badge, {
                            class: _normalizeClass(["mr-2", row.hasSheetDraft ? 'p-badge-danger' : 'p-badge-secondary']),
                            value: row.hasSheetDraft ? 'Has Draft' : 'No Draft'
                          }, null, 8, ["class", "value"])
                        ])
                      ], 12, _hoisted_79))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        (!_ctx.cloneSingleDialog.isLoading && _ctx.cloneSingleDialog.versions.length == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
              _createVNode(_component_FontAwesomeIcon, {
                icon: ['fas', 'image'],
                size: "2x"
              }),
              _hoisted_82
            ]))
          : _createCommentVNode("", true),
        (_ctx.cloneSingleDialog.isLoading)
          ? (_openBlock(), _createBlock(_component_TheTableLoading, { key: 1 }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["header", "visible", "onHide"])
  ], 64))
}